module.exports = __webpack_public_path__ + "img/twins.ab997635.svg";